import { render, staticRenderFns } from "./t-help.vue?vue&type=template&id=1a830350&scoped=true&"
import script from "./t-help.vue?vue&type=script&lang=js&"
export * from "./t-help.vue?vue&type=script&lang=js&"
import style0 from "./t-help.vue?vue&type=style&index=0&id=1a830350&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a830350",
  null
  
)

export default component.exports